import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-34aea19a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row d-flex" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "URL", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Enter a Youtube video link here.", -1))
const _hoisted_4 = {
  key: 0,
  class: "error"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Enable Audio", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createBlock(_component_el_form, {
    "hide-required-asterisk": "",
    ref: "form",
    "label-position": "top",
    model: _ctx.signageItemLayoutData
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _hoisted_3,
        (!_ctx.isUrlValid)
          ? (_openBlock(), _createElementBlock("p", _hoisted_4, "Invalid URL"))
          : _createCommentVNode("", true),
        _createVNode(_component_el_form_item, { prop: "url" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              ref: "urlInput",
              class: _normalizeClass({'url-invalid' : (!_ctx.isUrlValid),  'url-valid' : (_ctx.isUrlValid) }),
              modelValue: _ctx.signageItemLayoutData.url,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.signageItemLayoutData.url) = $event)),
              placeholder: "URL",
              "suffix-icon": {'el-icon-warning url-invalid':(!_ctx.isUrlValid), 'el-icon-check url-valid':(_ctx.isUrlValid)},
              onFocus: _ctx.selectAllUrl,
              onMousedown: _ctx.handleMouseDown
            }, null, 8, ["class", "modelValue", "suffix-icon", "onFocus", "onMousedown"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, null, {
          default: _withCtx(() => [
            _createElementVNode("label", null, [
              _createVNode(_component_el_switch, {
                modelValue: _ctx.playSound,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.playSound) = $event))
              }, null, 8, ["modelValue"]),
              _hoisted_5
            ])
          ]),
          _: 1
        })
      ]),
      _createVNode(_component_el_divider, { class: "mt-0" })
    ]),
    _: 1
  }, 8, ["model"]))
}